<template>
  <!-- Only render when there are notifications to announce -->
  <v-list
    v-if="currentNotifications.length > 0"
    two-line
    fixed
    right
    bottom
    class="notifications-overlay"
    color="transparent"
    role="status"
    aria-live="polite"
  >
    <v-list-item
      v-for="notification in currentNotifications"
      :key="notification.id"
      full-width
      dense
      link
      v-bind="notification.navigateTo"
      :class="[notification.color, 'notifications-overlay-list-item']"
    >
      <!-- Icon -->
      <v-list-item-avatar size="25">
        <v-icon
          :color="notification.iconColor"
          aria-hidden="true"
        >
          {{ `fad fa-${notification.icon}` }}
        </v-icon>
      </v-list-item-avatar>

      <!-- Text -->
      <v-list-item-content>
        <v-list-item-title
          v-if="notification.message"
          v-text="notification.message"
        />

        <v-list-item-subtitle
          v-if="notification.date"
          v-text="toReadableDate(notification.date)"
        />
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapGetters } from "vuex";
import { toHumanized } from "@/utils/date.utils";

const NOTIFICATION_QUEUE_LIMIT = 3;

export default {
    name: "NotificationsOverlay",
    data() {
        return {
            queue: [],
            currentNotifications: [],
            shownIds: [],
        }
    },
    computed: {
        ...mapGetters(["notifications"]),
    },
    watch: {
        notifications(newValue, oldValue) {
            if (newValue.length === 0) {
                return;
            }

            const queueNotifyIds = this.queue.map((notification) => notification.id);

            const notifications = ((newValue || {}).data || newValue || [])
                .filter((notification) => !queueNotifyIds.includes(notification.id) ||
                !this.shownIds.includes(notification.id))

            if (notifications.length === 0) {
                return;
            }

            this.queue.push(notifications);
            this.queue = this.queue.flat();
            this.shownIds.push(notifications.map((notification) => notification.id))
            this.shownIds = this.shownIds.flat();
        },
        queue(newValue, oldValue) {
            const currentNotifyIds = this.currentNotifications.map((notification) => notification.id);

            if (this.currentNotifications.length >= NOTIFICATION_QUEUE_LIMIT) {
                return;
            }

            newValue
                .filter((notification) => !currentNotifyIds.includes(notification.id) && notification.canShow)
                .slice(0, NOTIFICATION_QUEUE_LIMIT)
                .forEach((notification) => {
                    this.currentNotifications.push(notification)
                    this.currentNotifications = this.currentNotifications.flat();

                    if (notification.timeout) {
                        setTimeout(this.onCloseNotification.bind(this, notification), notification.timeout);
                    }
                })
        }
    },
    methods: {
        toLink(link) {
            this.$router.push({
                path: new URL(link).pathname
            });
        },
        toReadableDate(date) {
            return toHumanized(date);
        },
        async onCloseNotification(notification) {
            const currentNotificationIndex = this.currentNotifications.indexOf(notification);
            const queueIndex = this.queue.indexOf(notification);

            this.currentNotifications.splice(currentNotificationIndex, 1);
            this.queue.splice(queueIndex, 1);
        }
    }
};
</script>


<style lang="scss" scoped>
@import '~/_variables.scss';

    .notifications-overlay  {
        width: 30%;
        position: fixed;
        bottom: 4rem;
        right: 1rem;
        z-index: 4;

        &-list-item {
            margin: 0.5rem 0;
        }
    }
</style>
